import { render, staticRenderFns } from "./jumpPage.vue?vue&type=template&id=c6433780&scoped=true"
import script from "./jumpPage.vue?vue&type=script&lang=js"
export * from "./jumpPage.vue?vue&type=script&lang=js"
import style0 from "./jumpPage.vue?vue&type=style&index=0&id=c6433780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6433780",
  null
  
)

export default component.exports